import { DropdownToggle } from 'reactstrap';
import styled from 'styled-components';
import { tableTheme } from './theme';

const Table = styled.table`
  width: 100%;
  margin-bottom: ${tableTheme.spacing.large};
  color: ${tableTheme.colors.primary};
  border-bottom: 1px solid ${tableTheme.colors.border};
  table-layout: fixed;
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const TableHeader = styled.th`
  cursor: pointer;
  color: ${tableTheme.colors.secondary};
  border-top: 1px solid ${tableTheme.colors.border};
  border-bottom: 1px solid ${tableTheme.colors.border};
  padding: 12px;
  font-size: ${tableTheme.fontSize.small};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${tableTheme.fontWeight.bold};
  overflow: hidden;
`;

const TableData = styled.td`
  border-top: 1px solid ${tableTheme.colors.border};
  color: ${tableTheme.colors.textPrimary};
  vertical-align: middle;
  padding: 6px 24px;
  font-size: ${tableTheme.fontSize.medium};
  white-space: nowrap;
  display: table-cell;
  vertical-align: inherit;
  unicode-bidi: isolate;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TableRow = styled.tr`
  display: table-row;
  vertical-align: inherit;
  unicode-bidi: isolate;
  border-color: inherit;
`;

const TableHeaderContainer = styled.div`
  display: flexbox;
  align-items: center;
  justify-content: initial;
  width: fit-content;
  height: 100%;
  pointer-events: ${(props) => (props.resizing ? 'none' : 'auto')};
`;

const ResizeHandle = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: ${tableTheme.spacing.large};
  gap: ${tableTheme.spacing.medium};
`;

const ClearFilters = styled.span`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: ${tableTheme.spacing.small};
`;

const DropdownToggleStyled = styled(DropdownToggle)`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  margin-right: 3px;
  width: 2.5rem;
  height: 2.27rem;

  &:hover {
    background: none;
    border: none;
    box-shadow: none;
  }
`;

const DropdownItemContent = styled.div`
  color: ${tableTheme.colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${tableTheme.spacing.medium};
`;

const IconWrapper = styled.span`
  margin-right: ${tableTheme.spacing.medium};
`;

const ButtonSeparator = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${tableTheme.colors.border};
`;

export {
  Table,
  TableContainer,
  TableHeader,
  TableData,
  TableRow,
  TableHeaderContainer,
  ResizeHandle,
  FilterContainer,
  ClearFilters,
  DropdownToggleStyled,
  DropdownItemContent,
  IconWrapper,
  ButtonSeparator
};
